// TableMessagesForModeration.jsx
import React, { useState } from 'react';
import ModalAnswer from './ModalAnswer';
import AnswerMessage from './AnswerMessage';

const statusesOfChildKeys = {
    'myrequest': 'Заявка власної дитини',
    'children': 'Власна, в садочку',
    'otherrequest': 'Заявка іншої дитини',
    'otherchildren': 'Інша, в садочку'
};

const statusesOfMessage = {
    'info': 'Повідомлення',
    'claim': 'Скарга',
    'needhelp': 'Потрібна допомога' 
};

const TableMessagesForModeration = ({ messages, onUpdate }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);

    const showModalAnswer = (message) => {
        setSelectedMessage(message);
        setShowModal(true);
    };

    const closeModalAnswer = () => {
        setSelectedMessage(null);
        setShowModal(false);
        onUpdate();
    };

    return (
        <div className="card">
            <div className="card-header bg-light">
                <h5 className="card-title mb-0">Результати пошуку</h5>
            </div>
            <div className="card-body p-0">
                <div className="table-responsive">
                    <table className="table table-striped table-hover mb-0">
                        <thead className="table-light">
                            <tr>
                                <th scope="col">Тип звернення</th>
                                <th scope="col">Автор</th>
                                <th scope="col">Дата</th>
                                <th scope="col">Дитина</th>
                                <th scope="col">Звернення</th>
                                <th scope="col">Дія</th>
                            </tr>
                        </thead>
                        <tbody>
                            {messages.map((message, index) => (
                                <tr key={message._id || index}>
                                    <td>
                                        <span className="badge bg-secondary">
                                            {statusesOfMessage[message.genInfo?.needResponse?.status] || 'Невідомо'}
                                        </span>
                                    </td>
                                    <td>
                                        <div>
                                            <div className="fw-medium">{message.genInfo?.author?.name}</div>
                                            <small className="text-muted">{message.genInfo?.author?.email}</small>
                                            <br />
                                            <small className="text-muted">{message.genInfo?.author?.phone}</small>
                                        </div>
                                    </td>
                                    <td>
                                        {new Date(message.createdAt).toLocaleString('uk-UA')}
                                    </td>
                                    <td>
                                        <div>
                                            <div>{message.genInfo?.child?.firstName || 'Не вказано'}</div>
                                            <small className="text-muted">
                                                {message.genInfo?.child?.birthCertificateNumber || 'Без номеру'}
                                            </small>
                                            <br />
                                            <small className="text-muted">
                                                {statusesOfChildKeys[message.genInfo?.child?.status] || ''}
                                            </small>
                                        </div>
                                    </td>
                                    <td>
                                        <div 
                                            className="text-truncate" 
                                            style={{ maxWidth: '200px' }}
                                            title={message.messages?.[0]?.text}
                                        >
                                            {message.messages?.[0]?.text || 'Текст відсутній'}
                                        </div>
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => showModalAnswer(message)}
                                        >
                                            Відповісти
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal for answering */}
            <ModalAnswer
                show={showModal}
                onClose={closeModalAnswer}
                headerMessage="Надайте кваліфіковану відповідь"
            >
                {selectedMessage && (
                    <AnswerMessage 
                        message={selectedMessage} 
                        onClose={closeModalAnswer} 
                    />
                )}
            </ModalAnswer>
        </div>
    );
};

export default TableMessagesForModeration;